__turbopack_context__.v({
  "moreBtn": "loadMore-module-scss-module__jPFvLa__moreBtn",
});
